import React, { useRef, useEffect } from 'react'
import './style.scss'
import '../../assets/style/main.css'
import CARD_1 from '../../assets/images/icons/idencard-icon.png'
import CARD_2 from '../../assets/images/icons/faceocr-icon.png'
import SignIn_Navbar from '../../components/SignIn_Navbar'
import PageLoader, {isPageLoading} from '../../components/PageLoader'
import { Base_API } from '../../_actions/matcher'

function KYC_Overview() {
    let onceMount = useRef(true);

    useEffect(() => {
        if(onceMount.current)
        {
            pageInit();
            onceMount.current = false; 
        }
    }, [])

    const pageInit = async() => {
        isPageLoading(false);
    }

    const onSubmit = () => {
        location.href = `${Base_API.pathWeb}/n-health/kyc/overview-2`;
    }

    return (
        <div className="kyc-ovw-con">
            <SignIn_Navbar canClose={false} />
            <PageLoader />

            <h1 className='header-text'>เตรียมเข้าสู่ขั้นตอนการยืนยันตัวตน</h1> 
            <div className="group">
                <div className="card-item">
                    <div className="left">
                        <img src={CARD_1} />
                    </div>
                    <div className="right">
                        <h3>ถ่ายรูปด้านหน้าบัตรประชาชน / ถ่ายรูปพาสปอร์ต</h3>
                        <p>ใช้บัตรประชาชน/ถ่ายรูปพาสปอร์ต ในปัจจุบันและ ไม่หมดอายุ ภายใน 60 วัน</p>
                    </div>
                </div>
                <div className="card-item">
                    <div className="left">
                        <img src={CARD_2} />
                    </div>
                    <div className="right">
                        <h3>สแกนใบหน้า</h3>
                        <p>โปรดไม่สวมหมวก, แว่นกันแดด, ไม่หลับตาขณะสแกนใบหน้าและไม่แต่งตัวโป๊เปลือย</p>
                    </div>
                </div>
            </div>

            <button className='submit-btn' onClick={onSubmit}>
                ถัดไป
            </button>

            <div className="copyright">
                <p>พบปัญหาติดต่อ Call Center <span className="text-blue">02-762-4000</span> หรือ <br/> <span className='text-blue'>ศูนย์ช่วยเหลือ</span></p>
            </div>
        </div>
    )
}

export default KYC_Overview